var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEarnUsd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2005_1112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 72C55.8822 72 72 55.8822 72 36C72 16.1177 55.8822 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8822 16.1177 72 36 72Z",
    fill: "url(#paint0_radial_2005_1112)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M49.7167 32.7332L50.0911 33.3075C54.3136 39.785 53.3706 48.2684 47.8238 53.7034C44.5605 56.9006 40.2837 58.4996 36.0068 58.5C36.0068 58.5 36.0068 58.5 49.7167 32.7332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.0056 40.5644L49.7154 32.7332C36.0056 58.5 36.0056 58.5 36.0056 58.5C36.0056 52.8882 36.0056 46.4577 36.0056 40.5644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2819 32.7332L21.9075 33.3075C17.6848 39.785 18.6279 48.2684 24.1747 53.7034C27.4379 56.9006 31.7147 58.4996 35.9917 58.5C35.9917 58.5 35.9917 58.5 22.2819 32.7332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M35.9876 40.5644L22.2778 32.7332C35.9876 58.5 35.9876 58.5 35.9876 58.5C35.9876 52.8882 35.9876 46.4577 35.9876 40.5644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.0098 23.0698V36.5764L47.8194 29.8274L36.0098 23.0698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M36.0066 23.0698L24.1885 29.8273L36.0066 36.5764V23.0698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0066 11.7106L24.1885 29.8315L36.0066 23.055V11.7106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M36.0098 23.0531L47.8283 29.8299L36.0098 11.7V23.0531Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2005_1112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36 36) rotate(90) scale(60.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A99FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050A5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2005_1112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEarnUsd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/earn-usd.a6f3841f6ff037f2c10ba0df58d96ddd.svg";